var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.item.id))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.item.name))]),_c('td',{staticClass:"text-right"})])}
var staticRenderFns = []

export { render, staticRenderFns }